// src/components/FiscalGuard.js
// Módulos novos do Fiscal (port do ZADRA) liberados só para o grupo 'adm' e o Thiago
// (09/10/2026). A trava de verdade é no backend (core/fiscal_acesso.py); aqui é o menu e
// a rota. Para liberar mais gente, mude as duas listas abaixo E as do backend.
import React, { useEffect, useState } from 'react';
import axios from 'axios';

export const FISCAL_GRUPOS_LIBERADOS = ['adm'];
export const FISCAL_IDS_LIBERADOS = [6, 13]; // Thiago, Ismael (22/10/2026)

export const fiscalLiberado = (grupo, userId) =>
  FISCAL_GRUPOS_LIBERADOS.includes((grupo || '').toLowerCase().trim()) || FISCAL_IDS_LIBERADOS.includes(Number(userId));

const idDoToken = () => {
  try {
    const token = localStorage.getItem('access') || '';
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload.user_id;
  } catch {
    return null;
  }
};

export default function FiscalGuard({ children }) {
  const [estado, setEstado] = useState(null); // null = verificando | 'ok' | 'negado'

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE}/api/verificar-grupo/`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('access')}` },
    })
      .then((r) => setEstado(fiscalLiberado(r.data.grupo, idDoToken()) ? 'ok' : 'negado'))
      .catch(() => setEstado('negado'));
  }, []);

  if (estado === null) {
    return <div className="text-center py-5 text-muted"><i className="fas fa-spinner fa-spin me-2"></i>Verificando acesso...</div>;
  }
  if (estado === 'negado') {
    return (
      <div className="container mt-5" style={{ maxWidth: 560 }}>
        <div className="shadow-sm rounded bg-white p-4 text-center">
          <i className="fas fa-lock fa-2x mb-3" style={{ color: '#f1be48' }}></i>
          <h5 className="fw-bold" style={{ color: '#212529' }}>Módulo ainda não liberado</h5>
          <p className="text-muted mb-0">Os novos módulos do Fiscal estão em implantação e, por enquanto, só o grupo adm tem acesso.</p>
        </div>
      </div>
    );
  }
  return children;
}
